/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsEnergyConsumptionRateFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsEnergyConsumptionRateFormat = ClosedEnum<
  typeof GetApiV3MetricsEnergyConsumptionRateFormat
>;

export type GetApiV3MetricsEnergyConsumptionRateRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsEnergyConsumptionRateFormat | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
  /**
   * Node ID
   */
  nodeId?: string | null | undefined;
};

/** @internal */
export const GetApiV3MetricsEnergyConsumptionRateFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsEnergyConsumptionRateFormat> = z
    .nativeEnum(GetApiV3MetricsEnergyConsumptionRateFormat);

/** @internal */
export const GetApiV3MetricsEnergyConsumptionRateFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsEnergyConsumptionRateFormat> =
    GetApiV3MetricsEnergyConsumptionRateFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsEnergyConsumptionRateFormat$ {
  /** @deprecated use `GetApiV3MetricsEnergyConsumptionRateFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsEnergyConsumptionRateFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsEnergyConsumptionRateFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsEnergyConsumptionRateFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsEnergyConsumptionRateRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsEnergyConsumptionRateRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    start: z.nullable(z.number()).default(null),
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsEnergyConsumptionRateFormat$inboundSchema.default(
      "json",
    ),
    step: z.number().default(7200),
    node_id: z.nullable(z.string()).default(null),
  }).transform((v) => {
    return remap$(v, {
      "node_id": "nodeId",
    });
  });

/** @internal */
export type GetApiV3MetricsEnergyConsumptionRateRequest$Outbound = {
  start: number | null;
  end: number | null;
  format: string;
  step: number;
  node_id: string | null;
};

/** @internal */
export const GetApiV3MetricsEnergyConsumptionRateRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsEnergyConsumptionRateRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsEnergyConsumptionRateRequest
  > = z.object({
    start: z.nullable(z.number()).default(null),
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsEnergyConsumptionRateFormat$outboundSchema.default(
      "json",
    ),
    step: z.number().default(7200),
    nodeId: z.nullable(z.string()).default(null),
  }).transform((v) => {
    return remap$(v, {
      nodeId: "node_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsEnergyConsumptionRateRequest$ {
  /** @deprecated use `GetApiV3MetricsEnergyConsumptionRateRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsEnergyConsumptionRateRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsEnergyConsumptionRateRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsEnergyConsumptionRateRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsEnergyConsumptionRateRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsEnergyConsumptionRateRequest$Outbound;
}

export function getApiV3MetricsEnergyConsumptionRateRequestToJSON(
  getApiV3MetricsEnergyConsumptionRateRequest:
    GetApiV3MetricsEnergyConsumptionRateRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsEnergyConsumptionRateRequest$outboundSchema.parse(
      getApiV3MetricsEnergyConsumptionRateRequest,
    ),
  );
}

export function getApiV3MetricsEnergyConsumptionRateRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsEnergyConsumptionRateRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsEnergyConsumptionRateRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsEnergyConsumptionRateRequest' from JSON`,
  );
}
